import React, { ChangeEvent, useMemo } from 'react';
import DataTable from '../../../../../../common/components/DataTable';
import { IDataTableColumn } from '../../../../../../common/types/dataTable';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../../template/store';
import {
  updateSelectedCheckList,
  updateselectedCheckListRemark,
} from '../../../instructionSlice/DOExtensionSlice';

interface CheckListTableProps {
  accessGroupLevel: string[];
}

const CheckListTable: React.FC<CheckListTableProps> = ({ accessGroupLevel }) => {
  const dispatch = useDispatch<AppDispatch>();
  const checkListData = useSelector((state: RootState) => state.doExtension.checkList);
  const demurrageViewForm = useSelector(
    (state: RootState) => state.doExtension.demurrageFormView
  );
  const documentCheck = (rowData: any) => {
    const { docId, check, groupLevel } = rowData.row.original;

    return (
      <>
        <span className="radio p-2">
          <label>
            {' '}
            Yes{' '}
            <input
              type="radio"
              name={docId}
              value="true"
              className="form-check-input"
              disabled={
                accessGroupLevel[groupLevel] != 'Y' || groupLevel != demurrageViewForm.groupLevel
              }
              checked={check == 'Y'}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                dispatch(
                  updateSelectedCheckList({
                    check: 'Y',
                    docId: docId,
                  })
                );
              }}
            />
          </label>
        </span>
        <span className="radio p-2">
          <label>
            {' '}
            No{' '}
            <input
              type="radio"
              name={docId}
              value="false"
              className="form-check-input"
              disabled={
                accessGroupLevel[groupLevel] != 'Y' || groupLevel != demurrageViewForm.groupLevel
              }
              checked={check === 'N'}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                dispatch(
                  updateSelectedCheckList({
                    check: 'N',
                    docId: docId,
                  })
                );
              }}
            />
          </label>
        </span>
      </>
    );
  };

  const TableCheckListRemark = (rowData: any) => {
    const { docId, remarks, groupLevel } = rowData.row.original;

    return (
      <input
        type="text"
        className="fs--2 form-control"
        disabled={
          accessGroupLevel[groupLevel] != 'Y' || groupLevel != demurrageViewForm.groupLevel
        }
        defaultValue={remarks}
        onBlur={(e) => {
          e.preventDefault();
          dispatch(
            updateselectedCheckListRemark({
              docId,
              remarks: e.target.value,
            })
          );
        }}
      />
    );
  };

  const TableCheckListDocName = (rowData: any) => {
    const { name } = rowData.row.original;
    return <span title={name}>{name}</span>;
  };

  const docCheckColumns: IDataTableColumn[] = useMemo(
    () => [
      {
        accessor: 'docId',
        Header: '',
        width: 200,
        maxWidth: 230,
      },
      {
        accessor: 'name',
        Header: 'Check List Name',
        Cell: TableCheckListDocName,
        width: 200,
        maxWidth: 230,
      },
      {
        accessor: 'check',
        Header: 'Check',
        Cell: documentCheck,
        width: 150,
        maxWidth: 150,
      },
      {
        accessor: 'remarks',
        Header: 'Remarks ',
        Cell: TableCheckListRemark,
        width: 180,
        maxWidth: 180,
      },
      {
        accessor: 'linerId',
        Header: 'Liner ID',
        width: 150,
        maxWidth: 150,
      },
      {
        accessor: 'checkListUpdated',
        Header: 'Last Updated ',
        width: 180,
        maxWidth: 180,
      },
    ],
    [accessGroupLevel, demurrageViewForm.groupLevel]
  );

  return (
    <div className="demmurageTableCheckList">
      <DataTable
        data={checkListData ?? []}
        gridName="CHECK_LIST_DO_EXTENSION"
        columns={docCheckColumns}
        sortable={false}
        searchable={false}
        showColumnFilter={false}
        selection={false}
        perPage={10}
        pagination={false}
        showExport={false}
        uniqueFilterKey="releaseAttachment"
        autoHeight={true}
        staticHiddenCols={['docId']}
      />
    </div>
  );
};

export default CheckListTable;
